import { render } from "./ShowcaseUltrazaem.vue?vue&type=template&id=229a7ad5"
import script from "./ShowcaseUltrazaem.vue?vue&type=script&lang=js"
export * from "./ShowcaseUltrazaem.vue?vue&type=script&lang=js"

import "./ShowcaseUltrazaem.vue?vue&type=style&index=0&id=229a7ad5&lang=css"
import "./ShowcaseUltrazaem.vue?vue&type=style&index=1&id=229a7ad5&lang=css"

import exportComponent from "/home/runner/work/leadsbroker-showcase/leadsbroker-showcase/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__